import { ApiLogTab } from "@/components/platform-catalog/ApiLogTab";
import { usePageTitle } from "@/lib/use-page-title";

/**
 * System → API logs - standalone viewer for pos_api_log_tbl entries.
 * Super_admin only (gated in the router + sidebar).
 */
export function ApiLogsPage(): JSX.Element {
  usePageTitle("API logs");
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-xl font-semibold tracking-tight sm:text-2xl">API logs</h1>
        <p className="text-sm text-muted-foreground">
          Every outbound HTTP call from provider plugins (Valor, Aeropay, …) recorded in{" "}
          <code className="font-mono text-[11px]">pos_api_log_tbl</code>. Toggle logging on/off via
          Platform Catalog → Features → External API Log.
        </p>
      </div>
      <ApiLogTab />
    </div>
  );
}
